<template>
  <div>
    <div class="list">
      <div>
        <div>账号</div>
        <div>{{ account.username }}</div>
      </div>
      <div>
        <div>账号审核状态</div>
        <template v-for="item in accountStateList">
          <el-tag :key="item.value" v-if="item.value == account.state" :type="item.type">{{ item.lable }}</el-tag>
        </template>
      </div>
      <div>
        <div>拥有权限代码</div>
        <div>{{ getRole(account.roles) }}</div>
      </div>
      <div>
        <div>姓名</div>
        <div>{{ details.fullName }}</div>
      </div>

      <div>
        <div>工作单位</div>
        <div>{{ details.workUnit }}</div>
      </div>
      <div>
        <div>联系电话</div>
        <div>{{ details.telephone }}</div>
      </div>
      <!-- <div>
        <div>申请日期</div>
        <div>{{ details.dateOfApplication }}</div>
      </div> -->
    </div>
  </div>
</template>

<script>
import {
  fileName,
  accountStateList,
  accountTypeList,
  memberTypeList,
} from "@/utils";
export default {
  props: ["details", "account"],
  data() {
    return {
      accountTypeList,
      memberTypeList,
      accountStateList,
      fileName,
    };
  },
  methods: {
    getRole(roles) {
      if (!roles || roles.length == 0) return "空";
      return roles
        .map((key) => {
          if (typeof key == "string") {
            return key;
          } else {
            return key.code;
          }
        })
        .join(",");
    },
  },
};
</script>
 
<style lang="less" scoped>
.list {
  padding-left: 18px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  // grid-template-rows: 30px 30px 30px;
  >div {
    padding: 13px 0;
    display: flex;
    align-items: center;
    gap: 20px;
    font-size: 17px;
    color: #000;
    box-sizing: border-box;
    max-width: 90%;

    >div:nth-child(1) {
      width: 150px;
      min-width: 150px;
    }

    >div:nth-child(2) {
      flex: 1;
    }

    >a {
      overflow: hidden;
      word-wrap: break-word;
    }
  }
}</style>